import { useContext } from 'react';
import { CollapsibleContext } from 'src/contexts/CollapsibleContext';

const useCollapsibleContext = () => useContext(CollapsibleContext);

export default useCollapsibleContext;